'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCustomResponse = makeCustomResponse;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeCustomResponse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      customResponseQuantity = _ref.customResponseQuantity,
      customResponseUnit = _ref.customResponseUnit;

  return _I18n2.default.text('conversations-schema.typicalResponseTime.customResponses.' + customResponseUnit, { count: customResponseQuantity });
}